import { render, staticRenderFns } from "./ArHistory.vue?vue&type=template&id=288d0b63"
import script from "./ArHistory.vue?vue&type=script&lang=js"
export * from "./ArHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports